import { render, staticRenderFns } from "./UnfinishedTasks.vue?vue&type=template&id=6b94b960"
import script from "./UnfinishedTasks.vue?vue&type=script&lang=js"
export * from "./UnfinishedTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports